import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import classNames from "classnames";
import { useStores } from "_common/hooks";

export default function GameChart({ game_id, isLight }) {
  const {
    authStore: { trading_view },
  } = useStores();
  return (
    <div className="relative h-[70vh] w-full">
      <iframe
        scrolling="no"
        frameBorder="0"
        src="https://www.tradingview-widget.com/embed-widget/advanced-chart/?locale=en_EN#%7B%22autosize%22%3Atrue%2C%22symbol%22%3A%22BINANCE%3ABTCUSDT%22%2C%22interval%22%3A%2215%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22dark%22%2C%22style%22%3A%221%22%2C%22hide_side_toolbar%22%3Afalse%2C%22allow_symbol_change%22%3Atrue%2C%22calendar%22%3Afalse%2C%22withdateranges%22%3Atrue%2C%22support_host%22%3A%22https%3A%2F%2Fwww.tradingview.com%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A%22100%25%22%2C%22utm_source%22%3A%22tradingm68.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22advanced-chart%22%2C%22page-uri%22%3A%22tradingm68.com%2Fm%2Ftrade%2FBTC%2FUSDT%22%7D"
        title="advanced chart TradingView widget"
        lang="en"
        style={{
          userSelect: "none",
          boxSizing: "border-box",
          display: "block",
          height: "100%",
          width: "100%",
        }}
      />
    </div>
  );
}
